<template>
    <rkm-overlay>
        <rkm-layout-body :title="`${id ? 'Edição' : 'Cadastro'} de procedimento`">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    v-if="!model || !model.exportado"
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="id"
                    @model-load="model = $event"
                    @save="handleSave"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/raas/procedimento/components/cadastro/Form'

export default {
    components: { Form },
    data: () => ({
        model: null
    }),
    methods: {
        handleSave() {

            this.handleExit()
        },
        handleExit() {

            this.$router.push({ name: 'raas-procedimento-index' })
        },
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>